import _ from 'lodash'
import quickActionBarManager from '../../mobileConversion/mobileEditorSettings/quickActionBarManager'
import quickActions from '../../mobileConversion/mobileEditorSettings/quickActions'
import component from '../../component/component'
import constants from '../../tpa/constants'
import tpaEventHandlersService from '../../tpa/services/tpaEventHandlersService'
import type {ComponentAfterAddDataFromExtEvent} from '@wix/document-manager-extensions/dist/src/extensions/components/hooks'
import type {Pointer, PS} from '@wix/document-services-types'
import tpaUtils from '../../tpa/utils/tpaUtils'
import componentStructureInfo from '../../component/componentStructureInfo'
import tpaWidgetService from '../../tpa/services/tpaWidgetService'
import experiment from 'experiment-amd'

function siteContainsLegacyActionBar(ps) {
    return quickActions.isEnabled(ps)
}

function isChatTpa(ps, compPointer) {
    const compData = component.data.get(ps, compPointer)
    const appDefinitionId = _.get(ps.dal.get(ps.pointers.general.getClientSpecMap()), [
        compData.applicationId,
        'appDefinitionId'
    ])
    return appDefinitionId === constants.APP_DEF_ID.CHAT || appDefinitionId === constants.APP_DEF_ID.AI_CHAT_ASSISTANT
}

function addedGluedWidget(ps, compPointer) {
    const shouldUpgradeActionBar = isChatTpa(ps, compPointer) && !siteContainsLegacyActionBar(ps)
    if (shouldUpgradeActionBar) {
        quickActionBarManager.addQuickActionBar(ps)
    }
}

const addedGluedWidgetFromExt = (ps: PS, data: ComponentAfterAddDataFromExtEvent) => {
    const {compToAddPointer} = data
    addedGluedWidget(ps, compToAddPointer)
}

function willRemoveGluedWidget(ps, compPointer) {
    const shouldRevertToLegacyActionBar =
        isChatTpa(ps, compPointer) && _(quickActionBarManager.getActions(ps)).reject('isDynamic').isEmpty()
    if (shouldRevertToLegacyActionBar) {
        quickActionBarManager.removeQuickActionBar(ps)
    }
}

function executeDisconnectHandler(ps: PS, compPointer) {
    tpaEventHandlersService.executeDisconnectHandler(compPointer.id)
}

const getChildrenWithParentValidation = (ps: PS, compPointer: Pointer) => {
    const children = ps.pointers.components.getChildren(compPointer)
    const validChildren = children.filter(child => {
        const actualParent = ps.pointers.components.getParent(child)
        return !actualParent || (actualParent && ps.pointers.components.isSameComponent(actualParent, compPointer))
    })
    return validChildren.concat(_.flatMap(validChildren, child => getChildrenWithParentValidation(ps, child)))
}

const deleteTpaChildren = async (ps: PS, compPointer: Pointer) => {
    const children = experiment.isOpen('dm_fixRemovalOfMismatchedChildren')
        ? getChildrenWithParentValidation(ps, compPointer)
        : ps.pointers.components.getChildrenRecursively(compPointer)
    return await Promise.all(
        children.map(child => {
            if (tpaUtils.isTpaByCompType(ps, componentStructureInfo.getType(ps, child))) {
                return tpaWidgetService.deleteWidget(ps, child)
            }
            return Promise.resolve()
        })
    )
}

export default {
    addedGluedWidget,
    addedGluedWidgetFromExt,
    willRemoveGluedWidget,
    executeDisconnectHandler,
    deleteTpaChildren
}
